<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        库存管理
      </div>
    </div>

    <!-- 
    <div class="wodma">


       <div class="wodma-a">月</div>
       <div class="wodma-a">季度</div>
       <div class="wodma-a">年</div>
       <div class="wodma-a">总</div>

    </div> -->

    <div class="hang-a"></div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ msglst }}</div>
          <div class="a3">累计新增直推回收站数(个)</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border);"
    >
      <el-form-item label="时间">
        <el-date-picker
          size="medium"
          v-model="value1"
          @change="getfamval"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="marginright: 10px"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="输入搜索">
        <el-input v-model="keyword" placeholder="请输入仓库名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchozhi">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width:100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="姓名" prop="saleName"> </el-table-column>

      <el-table-column label="ID" prop="saleId"> </el-table-column>

      <el-table-column label="新增直推回收站数" prop="zhiNum">
      </el-table-column>

      <el-table-column label="新增分配回收站数" prop="fenNum">
      </el-table-column>

      <el-table-column label="新增绑定总数" prop="allNum"> </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      value1: "",
      msglst: "",
      tableData: [],
      shanghai: "",
      totalCount: 0,
      keyword: "",
      startTime: "",
      endTime: "",

      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {
    this.getSaleAchiEveTotal(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    getchozhi() {
      this.value1="",
      (this.startTime = ""),
        (this.endTime = ""),
        (this.keyword = ""),
        this.getSaleAchiEveTotal(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxu() {
      this.getSaleAchiEveTotal(this.searlist.curPage, this.searlist.pageSize);
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getSaleAchiEveTotal(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getSaleAchiEveTotal(v, this.searlist.pageSize);
    },

    getSaleAchiEveTotal(curr, pagesize) {
      this.$api.activitymsg
        .getSaleAchiEveTotal({
          beginTime: this.startTime,
          endTime: this.endTime,
          keyword: this.keyword,
          current: curr,
          size: pagesize,
        })
        .then((e) => {
          this.tableData = e.data;
          this.msglst = e.msg;
          this.totalCount = e.totalCount;
        });
    },

    getfamval() {
      var date = new Date(this.value1[0]);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;

      //   var h=date.getHours();
      //  var mm= date.getMinutes()
      //  var s=  date.getSeconds()

      this.startTime = y + "-" + m + "-" + d;

      console.log("开始", this.startTime);

      var date = new Date(this.value1[1]);
      console.log(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;

      //   var h=date.getHours();
      //  var mm= date.getMinutes()
      //  var s=  date.getSeconds()

      this.endTime = y + "-" + m + "-" + d;
    },

    getchakxq() {
      this.$router.push("orderitem");
    },
  },
};
</script>

<style scoped>
.hang-a {
  height: 20px;
}

.wodma-a {
  width: 50px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px var(--input-border);
}

.wodma {
  display: flex;
}

.con-let {
  height: 50px;
}

.a7 {
  width: 700px;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  /* width: 300px; */
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
